import Vue from "vue";
import TableModal from "../components/TableModal.vue";
/**
 *
 * @param {Object} json
 */
export default function modal(data, settings) {
  const dialog = new Vue({
    methods: {
      closeHandler() {
        return function() {
          dialog.$destroy();
          dialog.$el.remove();
        };
      }
    },
    render(h) {
      return h(TableModal, {
        props: {
          data,
          settings
        },
        on: {
          close: this.closeHandler()
        }
      });
    }
  }).$mount();
  document.body.appendChild(dialog.$el);
}
